import {
    SHOPIFY_SESSION_REFERRER_SUCCESS,
    SHOPIFY_SESSION_REFERRER_LOADING,
  } from '../actions/SessionByReferrerAction';
  
  const initialState = {
    SessionByReffererData: [],
    isLoading: true
  };
  
  const SessionByReferrerReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case SHOPIFY_SESSION_REFERRER_SUCCESS:
        return { ...state, SessionByReffererData: action.data, isLoading: false };
      case SHOPIFY_SESSION_REFERRER_LOADING:
        return { ...state, isLoading: action.isLoading };
      default:
        return state;
    }
  };
  
  export default SessionByReferrerReducer;
  